import { getApiBaseUrl } from '../../../utils/apiConfig';

function authHeaders() {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  };
}

function isFetchOk(res) {
  return res.ok || res.status === 304;
}

export async function fetchTourVirtualStatus(tourKey, tourVersion) {
  const params = new URLSearchParams({ tourKey, tourVersion });
  const res = await fetch(`${getApiBaseUrl()}/api/tour/virtual/status?${params}`, {
    headers: authHeaders(),
    cache: 'no-store',
  });
  const json = await res.json().catch(() => ({}));
  if (!isFetchOk(res) || !json.success) {
    throw new Error(json.message || 'Erro ao consultar tour.');
  }
  return Boolean(json.data?.completed);
}

export async function markTourVirtualComplete(tourKey, tourVersion) {
  const res = await fetch(`${getApiBaseUrl()}/api/tour/virtual/complete`, {
    method: 'POST',
    headers: authHeaders(),
    cache: 'no-store',
    body: JSON.stringify({ tourKey, tourVersion }),
  });
  const json = await res.json().catch(() => ({}));
  if (!isFetchOk(res) || !json.success) {
    throw new Error(json.message || 'Erro ao registrar tour.');
  }
  return true;
}
